import React from 'react';
import styled from '@emotion/styled';

const StyledSvg = styled.svg`
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const CloseIcon = () => (
  <StyledSvg width="15" height="15" viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg">
    <rect x="0" y="1.41422" width="2" height="18" transform="rotate(-45 0 1.41422)" fill="currentColor" />
    <rect width="2" height="18" transform="matrix(-0.7071 -0.7071 -0.7071 0.7071 14.1422 1.4142)" fill="currentColor" />
  </StyledSvg>
);

export const BackIcon = () => (
  <StyledSvg width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 7H2M2 7L8 1M2 7L8 13.5" stroke="currentColor" strokeWidth="2"/>
  </StyledSvg>
  
);
